/*! @pentacode/ui v0.1.0 */
//#region src/elements/icon/active-icon.ts
function e(e, t) {
	return t ? `${e}:active` : e;
}
//#endregion
export { e as activeIcon };

//# sourceMappingURL=active-icon.js.map